"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography, BorderInputBox } from "@/shared/ui/atoms";
interface LabelInputProps {
  type: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  labelClassName?: string;
  labelSize?: number;
  labelLineHeight?: number;
  helperText?: string;
}
const LabelInput = t0 => {
  const $ = _c(21);
  const {
    type,
    label,
    placeholder,
    value,
    onChange,
    autoComplete,
    labelClassName,
    labelSize,
    labelLineHeight,
    helperText
  } = t0;
  const t1 = `${labelClassName} ${helperText && "flex items-center gap-2"}`;
  let t2;
  if ($[0] !== label || $[1] !== labelLineHeight || $[2] !== labelSize || $[3] !== t1) {
    t2 = <Typography className={t1} size={labelSize} lineHeight={labelLineHeight}>{label}</Typography>;
    $[0] = label;
    $[1] = labelLineHeight;
    $[2] = labelSize;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== helperText) {
    t3 = helperText && <Typography size={12} className="text-[#9CA3AF]">{helperText}</Typography>;
    $[5] = helperText;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = autoComplete || undefined;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      color: "#E1E2E4",
      borderWidth: "1px",
      radius: "8px"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      "--fs": 16,
      "--lh": 22
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onChange || $[13] !== placeholder || $[14] !== t5 || $[15] !== type || $[16] !== value) {
    t8 = <BorderInputBox type={type} placeholder={placeholder} value={value} onChange={onChange} autoComplete={t5} border={t6} className="fs p-4 w-full h-[56px] focus:!border-[#6B00D7] focus:outline-none" style={t7 as React.CSSProperties} />;
    $[12] = onChange;
    $[13] = placeholder;
    $[14] = t5;
    $[15] = type;
    $[16] = value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t4}{t8}</div>;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default LabelInput;